import { PickerType } from './constants'
import DatePicker from './pickers/DatePicker'
import DateRangePicker from './pickers/DateRangePicker'
import TimePicker from './pickers/TimePicker'
import moment from 'moment-mini'

export default {
  name: 'KDatePickerPane',
  provide() {
    return {
      context: this,
    }
  },
  props: {
    pickerType: String,
    weekStartDay: {
      type: Number,
      default: 7,
    },
    now: moment,
    value: [moment, Array],
    active: Boolean,
    unlinkViews: Boolean,
    shortcuts: Array,
    referenceValue: moment,
    disabledDate: Function,
    precision: String,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    handlePick(value) {
      this.$emit('input', value)
    },
    handlePicking(value) {
      this.$emit('picking', value)
    },
    getBaseData() {
      const events = {
        pick: this.handlePick,
        picking: this.handlePicking,
      }

      const data = {
        on: events,
      }

      return data
    },
    handleStartSelected(value) {
      this.$emit('startSelected', value)
    },
    handleEndSelected(value) {
      this.$emit('endSelected', value)
    },
    getPickerPane() {
      const data = this.getBaseData()

      switch (this.pickerType) {
        case PickerType.Time:
          return (
            <TimePicker
              {...data} />
          )
        case PickerType.DateRange:
          return (
            <DateRangePicker
              {...data}
              onStartSelected={this.handleStartSelected}
              onEndSelected={this.handleEndSelected}
            />
          )
        case PickerType.Date:
        default:
          return (
            <DatePicker {...data} />
          )
      }
    },
  },
  render() {
    return this.getPickerPane()
  },
}
